import axios from "axios";
import { getPriceCurrencyCode } from "../../Helper";

//Home Banner
export const getBannerAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/banners?banner_type=main_banner`
  );
  return data;
};



//Testimonial
export const getTesimonialAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/testimonials`
  );
  return data;
};

//Testimonial Youtube
export const getyoutubeAPI = async () => {
  let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/youtubes`);
  return data;
};

//Home Category
export const getCatagoryAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/home-categories`
  );
  return data;
};


//Home Testimonial
export const getHomeTestimonialAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/testimonials/home`
  );
  return data;
};


//Product List
export const ProductListAPI = async (
  path,
  searchPro,
  searchCol,
  searchShip,
  searchPrice,
  searchOrderBy,
  LIMIT,
  pageParam
) => {
  let data;
  const currencyCode = getPriceCurrencyCode();
  if (searchPro || searchCol || searchShip || searchPrice || searchOrderBy) {
    data = await axios.get(
      `${process.env.REACT_APP_API_URL}/products/list-search?category_product=${
        searchPro ? searchPro : ""
      }&colors=${searchCol ? searchCol : ""}&shipping=${
        searchShip ? searchShip : ""
      }&priceRange=${
        searchPrice ? searchPrice : ""
      }&currencyCode=${currencyCode}&orderBy=${searchOrderBy}&page=${pageParam}&limit=${LIMIT}`
    );
    //console.log(data.data)
    data.data.data[0]['tot'] = data.data.total;
    //console.log(data.data.data);
    return data.data.data;
  } else {
    data = await axios.get(
      `${process.env.REACT_APP_API_URL}/products/list-search?category_product=${path}&page=${pageParam}&limit=${LIMIT}`
    );
    //console.log(data.data)
    data.data.data[0]['tot'] = data.data.total;
    //console.log(data.data.data);
    return data.data.data;
  }
};


//Product List Search By Query Parameter
export const ProductListSearchQueryAPI = async (
  searchPage,
  LIMIT,
  pageParam
) => {
  let data;
  if (searchPage) {
    data = await axios.get(
      `${process.env.REACT_APP_API_URL}/products/search?name=${searchPage}&page=${pageParam}&limit=${LIMIT}`
    );
    //console.log(data.data.data)
    return data.data.data;
  } else {
    data = await axios.get(
      `${process.env.REACT_APP_API_URL}/products/list-search?category_product=${'search'}&page=${pageParam}&limit=${LIMIT}`
    );
    //console.log(data.data)
    return data.data.data;
  }
};


//Product List Search
export const ProductListSearchAPI = async (slug) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/category/${slug}`
  );
  return data.data[0].products;
};

//Product Details
export const getProductDetailAPI = async (path) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/details/${path[path.length - 1]}`
  );
  return data;
};

// checkout
export const getCheckOutDataAPI = async (userId) => {
  //let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/products/details/${path[path.length - 1]}`);
  const country_data = localStorage.getItem("country_data");
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/cart?customer_id=${userId}&country_code=${JSON.parse(country_data)?.country_code}`
  );
  //console.log(data)
  return data;
};

//Get All Category
export const getAllCategoryAPI = async () => {
  let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/categories`);
  return data;
};

//Get All Color
export const getAllColorAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/colors`
  );
  return data;
};

//Get Search Color
export const getSearchColors = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/search-colors`
  );
  return data;
};

// customer Address
export const getCustomerAddressAPI = async (id) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/customer/address/list?customer_id=${id}`
  );
  return data;
};


// customer Address by id
export const getCustomerAddressShippingAPI = async (id, address_id) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/customer/address/list/${address_id}?customer_id=${id}`
  );
  return data;
};


// customer Address Add
export const addCustomerAddressAPI = async (details) => {
  let { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/customer/address/add`,
    details
  );
  return data;
};
// customer Address update
export const updateCustomerAddressAPI = async (currentAdd) => {
  let { data } = await axios.put(
    `${process.env.REACT_APP_API_URL}/customer/address/update_address`,
    currentAdd
  );
  return data;
};
// customer address delete
export const deleteCustomerAddressAPI = async ({ id, userId }) => {
  let { data } = await axios.delete(
    `${process.env.REACT_APP_API_URL}/customer/address/remove?address_id=${id}&customer_id=${userId}`
  );
  return data;
};

//Pages
export const getPagesAPI = async (slug) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/pages/${slug}`
  );
  return data;
};

//Blog
export const getBlogAPI = async () => {
  let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/blog`);
  return data;
};

//Blog Details
export const getBlogDetailsAPI = async (slug) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/blog/${slug}`
  );
  return data;
};

//Tracking Order
export const getTrackingOrderAPI = async (order_id) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/order/track/${order_id}`
  );
  return data;
};

// Get Support Ticket 
export const getSupportTicketAPI = async (userId) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/customer/support-ticket/get?customer_id=${userId}`
  );
  return data;
};
// Get Support Ticket conv data 
export const getSupportTicketConvAPI = async (ticketId) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/customer/support-ticket/conv/${ticketId}`
  );
  return data;
};
// Create Support Ticket 
export const CreateSupportTicketAPI = async (ticketdata) => {
  let { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/customer/support-ticket/create`,
    ticketdata
  );
  return data;
};

// Message Support Ticket 
export const CreateSupportTicketMsgAPI = async (currentAdd) => {
  let { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/customer/support-ticket/reply/${currentAdd.support_ticket_id}`,currentAdd
  );
  return data;
};

//Order List

export const getOrderDataAPI = async (userId) => {
  let  {data}  = await axios.get(
    `${process.env.REACT_APP_API_URL}/customer/order/list?customer_id=${userId}`
  );
  return data;
};

//Blog
export const getreelAPI = async () => {
  let { data } = await axios.get(`${process.env.REACT_APP_API_URL}/reels`);
  return data;
};

//Rating
export const CreateRatingAPI = async (currentRating) => {
  let { data } = await axios.post(
    `${process.env.REACT_APP_API_URL}/products/reviews/submit`,currentRating
  );
  return data;
}

//Celebrity
export const getCelebrityAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/celebrity`
  );
  return data;
};


//Celebrityhome
export const getCelebrityHomeAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/celebrity/homepage`
  );
  return data;
};


//client diaries
/* export const getClientdiariesAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/clientdiaries`
  ); 
  return data;
}; */

export const getClientdiariesAPI = async () => {
  let { data } = await axios.get(
    //`${process.env.REACT_APP_API_URL}/clientdiaries`
    `${process.env.REACT_APP_API_URL}/clientdiaries`
  );
  return data;
};

//Home New Banner
export const getNewHomeAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/static/homepageecom`
  );
  return data;
};


//Catrgoty Child
export const getCategoryChildAPI = async (slug) => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/products/categories/${slug}`
  );
  return data;
};

//Google reviews
export const getReviewsAPI = async () => {
  let { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/static/homepageecom`
  );
  return data;
};